<div class="vote-page">

  <p-scrollPanel
    styleClass="vote-scroll-panel"
    [style]="{
      width: '100%',
      height: '100%'
    }"
  >

    <!-- NESSUNA VOTAZIONE DISPONIBILE -->

    <ng-container *ngIf="questions.length === 0 && loaded">

      <div class="vote-empty-wrapper">

        <div class="no-votes">

          <i class="pi pi-inbox"></i>

          <h2>
            Al momento non sono disponibili votazioni
          </h2>

        </div>

      </div>

    </ng-container>

    <!-- ELENCO VOTAZIONI -->

    <div
      class="vote-container"
      *ngIf="questions.length > 0"
    >

      <ng-container
        *ngFor="let question of questions; index as index"
      >

        <p-card styleClass="vote-card">

          <ng-template pTemplate="title">

            <div class="vote-card-title">
              {{ question.title }}
            </div>

          </ng-template>

          <ng-template pTemplate="subtitle">

            <div class="vote-card-description">
              {{ question.description }}
            </div>

          </ng-template>

          <ng-template pTemplate="footer">

            <div class="vote-card-actions">

              <p-button
                [disabled]="!question.isAuthorized"
                [label]="question.isAuthorized ? 'Vota ora' : 'Hai già votato!'"
                icon="pi pi-check-square"
                severity="success"
                (onClick)="voteNow(question)"
              ></p-button>

            </div>

          </ng-template>

        </p-card>

      </ng-container>

    </div>

  </p-scrollPanel>

</div>

<!-- ============================================================
     DIALOG VOTAZIONE
     ============================================================ -->

<p-confirmDialog
  #cd
  styleClass="vote-dialog"
  [closable]="false"
  [closeOnEscape]="false"
  [draggable]="false"
  [style]="{
    width: '560px',
    maxWidth: '96vw'
  }"
>

  <!-- INTESTAZIONE -->

  <ng-template pTemplate="header">

    <div class="vote-dialog-header">

      <div class="vote-dialog-header-icon">
        <i class="pi pi-check-square"></i>
      </div>

      <div class="vote-dialog-header-text">

        <span class="vote-dialog-header-title">
          Esprimi il tuo voto
        </span>

        <span class="vote-dialog-header-subtitle">
          Seleziona le risposte desiderate
        </span>

      </div>

    </div>

  </ng-template>

  <!-- CONTENUTO -->

  <ng-template pTemplate="message">

    <div class="vote-dialog-body">

      <!-- DESCRIZIONE VOTAZIONE -->

      <div class="vote-dialog-question">

        <h2>
          {{ selectedQuestion?.description }}
        </h2>

      </div>

      <!-- LIMITI RISPOSTE -->

      <div class="vote-dialog-limits">

        <div class="vote-limit-item">

          <i class="pi pi-check-circle"></i>

          <span>
            Numero minimo di risposte:
            <strong>
              {{ selectedQuestion?.minResponses }}
            </strong>
          </span>

        </div>

        <div class="vote-limit-item">

          <i class="pi pi-list"></i>

          <span>
            Numero massimo di risposte:
            <strong>
              {{ selectedQuestion?.maxResponses }}
            </strong>
          </span>

        </div>

      </div>

      <!-- ELENCO RISPOSTE -->

      <div class="vote-options">

        <ng-container
          *ngIf="selectedQuestion?.maxResponses === 1; else moreAnswers"
        >

          <ng-container
            *ngFor="let vote of selectedQuestion!.possibleVotes | sort"
          >

            <div class="vote-option">

              <p-checkbox
                [inputId]="'' + vote.voteId"
                [disabled]="isDisabled(vote)"
                (onChange)="voteChanged()"
                name="vote"
                [value]="vote"
                [(ngModel)]="selectedVotes"
              ></p-checkbox>

              <label
                [for]="'' + vote.voteId"
                class="vote-option-label"
              >
                {{ vote.answer }}
              </label>

            </div>

          </ng-container>

        </ng-container>

        <ng-template #moreAnswers>

          <ng-container
            *ngFor="let vote of selectedQuestion?.possibleVotes"
          >

            <div class="vote-option">

              <p-checkbox
                [inputId]="'' + vote.voteId"
                [disabled]="isDisabled(vote)"
                (onChange)="voteChanged()"
                name="vote"
                [value]="vote"
                [(ngModel)]="selectedVotes"
              ></p-checkbox>

              <label
                [for]="'' + vote.voteId"
                class="vote-option-label"
              >
                {{ vote.answer }}
              </label>

            </div>

          </ng-container>

        </ng-template>

      </div>

    </div>

  </ng-template>

  <!-- FOOTER -->

  <ng-template pTemplate="footer">

    <div class="vote-dialog-footer">

      <p-button
        icon="pi pi-times"
        severity="secondary"
        label="Annulla"
        (onClick)="cd.reject()"
      ></p-button>

      <p-button
        icon="pi pi-check"
        severity="success"
        label="Conferma"
        [disabled]="
          !selectedQuestion ||
          (!whiteSelected &&
            selectedVotes.length < selectedQuestion.minResponses)
        "
        (onClick)="cd.accept()"
      ></p-button>

    </div>

  </ng-template>

</p-confirmDialog>